export const transaksiMap = (data) => ({
  id: data?.id,
  title: data?.keterangan,
  start: new Date(data?.tanggal_diajukan),
  end: new Date(data?.tanggal_transaksi),
  type: "transaksi",
  unit_kerja: data?.id_unit_kerja,
});

export const realokasiMap = (data) => ({
  id: data?.id,
  title: data?.keterangan,
  start: new Date(data?.waktu_pengajuan),
  end: new Date(data?.waktu_pengajuan),
  type: "realokasi",
  unit_kerja: data?.unit_kerja,
});

export const umkMap = (data) => ({
  pk: data?.pk,
  title: data?.keterangan,
  start: new Date(data?.tanggal_mulai),
  end: new Date(data?.tanggal_selesai),
  type: "umk",
  unit_kerja: data?.id_unit_kerja,
});

export const umoMap = (data) => ({
  id: data?.id,
  title: data?.keterangan,
  start: new Date(data?.date_created),
  end: new Date(data?.untuk_tanggal), // or batas_akhir?
  type: "umo",
  unit_kerja: data?.id_unit_kerja,
});
